import { render, staticRenderFns } from "./KPDF.vue?vue&type=template&id=6ce4d92e&"
import script from "./KPDF.vue?vue&type=script&lang=js&"
export * from "./KPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports